import '../../core/components/app-root/AppRoot.css';
import './panel.css';
import '../../core/styles/focusRingStatic.css';
import './Sidebar.css';
export var buttonContainer = '_zdcge95-3-5-0';
export var dismissButton = '_zdcge97-3-5-0 _zdcge96-3-5-0';
export var expandButton = '_zdcge98-3-5-0 _zdcge96-3-5-0';
export var hint = '_zdcge93-3-5-0 _z0fq9b4-3-5-0 _z0fq9bd-3-5-0 _z0fq9b6-3-5-0 _z0fq9bc-3-5-0';
export var integratedControls = '_zdcge91-3-5-0';
export var integratedControlsDrawerHeader = '_zdcge9a-3-5-0';
export var integratedControlsPanel = '_zdcge99-3-5-0';
export var sidebar = '_zdcge90-3-5-0';